import React, { useEffect } from "react";
import { useAuth0 } from "../react-auth0-spa";

const PrivateRoute = ({ component: Component }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: window.location.pathname },
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect]);

  // Show nothing while loading, component when authenticated
  return loading ? null : isAuthenticated ? <Component /> : null;
};

export default PrivateRoute;
